import React from "react";
import { useParams } from "react-router";
import useFiringActions from "../hooks/useFiringActions";
import useFirebaseFiring from "../hooks/useFirebaseFiring";
import FiringForm from "./FiringForm";

const FiringEditPage = () => {
  const { editFiring } = useFiringActions();
  const { id } = useParams();

  const firing = useFirebaseFiring(id!);

  const handleSubmit = (formValues: any) => {
    const values = {
      project_id: firing!.project_id,
      order: firing!.order || 0,
      id: firing!.id,
      favourite: firing!.favourite || false,
      ...formValues,
    };
    editFiring(id!, values);
  };
  if (!firing) {
    return <div>Loading...</div>;
  }
  const initialValues = {
    name: "",
    notes: "",
    date: new Date(Date.now()),
    ...firing,
  };

  return (
    <div>
      <FiringForm onSubmit={handleSubmit} initialValues={initialValues} />
    </div>
  );
};

export default FiringEditPage;
